import React, { useEffect, useState } from 'react'
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import FilterListIcon from '@mui/icons-material/FilterList';
import '../style/Documenti.scss'
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import CircularProgress from '@mui/material/CircularProgress';
import IntervalPicker from '../components/IntervalPicker';
import { DateTime, Interval } from 'luxon';
import { setShowPicker } from "../features/settingSlice";
import Item from '../components/Gas/_Item';
import { setFatture } from '../features/gasSlice';

function DocumentiGas() {
    const dispatch = useDispatch()
    const customerCode = useSelector((user) => user.gas.info.customer_code);
    const [openFilter, setOpenFilter] = useState(false)
    const data = useSelector((user) => user.gas.fatture)
    const tagList = null
    const [counterPosts, setCounterPosts] = useState(5);
    const [currentTag, setCurrentTag] = useState('tutti');
    const showPicker = useSelector((user) => user.settings.showPicker);
    const [intervalFilter, setIntervalFilter] = useState({
        label: 'Tutti',
        interval: Interval.fromDateTimes(DateTime.local(2000), DateTime.local()),
    });

    /*
        data: data_data_scadenza
    */
    useEffect(() =>{
        init()
    },[customerCode])

    const init = async () => {
        
        const documentiApi = `https://my.revoluce.it/area_utente/gestione/api/deliveries/getFattureGas.php?codice_cliente=${customerCode}`
        await axios.get(documentiApi).then(({data}) => {
            const result = data.sort((a, b) => (a.data_emissione < b.data_emissione ? 1 : -1));
            dispatch(setFatture(result))
        })
    }
    const checkIsActive = (r) => {
        if(typeof currentTag === `string` ){
            return r === currentTag
        } else {
            return currentTag.has(r)
        }
    } 
    const toggleTag = (r) => {
        if(typeof currentTag !== `string` && currentTag.has(r)){
            currentTag.delete(r)
            if(currentTag.size === 0){
                setCurrentTag('tutti')
            } else {
                setCurrentTag(new Set ([...currentTag.values()]))
            }
        } else {
            setCurrentTag(prevState => prevState === 'tutti' ? (
                new Set ([r])
            ) : new Set ([...prevState.values(), r]) )
        }
    }

    const toggleTagLabel = (r) => {
        switch (r) {
            case 'fattura':
                return 'Fatture'
            case 'contratto':
                return 'Contratto'
            default:
                return 'Canone'
        }
    }

    const toDateTime = (dataItem) => DateTime.fromISO(dataItem.data_emissione);
    
    let monthsInterval, filteredData = [];
    if (data && data.length > 0) {
        const dates = [toDateTime(data[0]), toDateTime(data[data.length - 1])];
        const min = DateTime.min(...dates).startOf('month');
        const max = DateTime.max(...dates).endOf('month');
        monthsInterval = Interval.fromDateTimes(min, max);
        const { interval } = intervalFilter;
        filteredData = data.filter(r => interval.contains(toDateTime(r)));
    }

    const openIntervalFilter = () => {
        if (monthsInterval) dispatch(setShowPicker(true));
    };

    return (
        <>
            <div className="documenti">
                {data === null ? (
                    <div className="loader">
                        <CircularProgress />
                    </div>
                ) : (
                <>
                      
                    <div className="header">
                        <div className="filterDate" onClick={openIntervalFilter}>
                            <div className="icon">
                                <CalendarTodayIcon />
                            </div>
                            <p className="label">{intervalFilter.label}</p>
                        </div>
                        <div className="filterTag" onClick={() => setOpenFilter(!openFilter)}>
                            <p className="label" style={openFilter ? {color: '#000'} : {color: '#697386'}}>Filtra documenti</p>
                            <div className="icon" style={openFilter ? {color: '#000'} : {color: '#697386'}}>
                                <FilterListIcon />
                            </div>
                        </div>
                    </div>
                    {openFilter ? (
                        <ul className="tags">
                            <li onClick={() => setCurrentTag('tutti')} className={currentTag === 'tutti' ? 'tag active' : 'tag'}>
                                <p>Tutti</p>
                            </li>
                            {tagList !== null ? (
                                tagList.map((r, i) => <li key={i} onClick={() => toggleTag(r)} className={checkIsActive(r)  ? 'tag active' : 'tag'}>
                                    <p>{toggleTagLabel(r)}</p>
                                </li>)
                            ) : null}
                        </ul>
                    ) : null}
                    <div className="items">
                        {currentTag === 'tutti' ? (
                            filteredData.slice(0, counterPosts).map((r, i) => (
                                <Item key={i} item={r} />
                            ))
                        ) : (
                            filteredData.filter((dato) => currentTag.has(dato.tag)).slice(0, counterPosts).map((r, i) => (
                                <Item key={i} item={r} />
                            ))
                        )}
                        {data === null ? null : counterPosts >= filteredData.length ? (
                            <div className="lastItem">
                                <p className="no-more">Non ci sono altri documenti da visualizzare</p>
                            </div>
                        ) : (
                            <div className="lastItem" onClick={() => setCounterPosts(counterPosts + 3)}>
                                <p className="load-more">Clicca per caricare altri documenti</p>
                            </div>
                        )}
                    </div>  
                </>
                )}
            </div>
            {showPicker && <IntervalPicker monthsInterval={monthsInterval} onSelect={(newIntervalFilter) => {
                setIntervalFilter(newIntervalFilter);
                dispatch(setShowPicker(false));
            }} />}
        </>
    )
}

export default DocumentiGas
